import React from "react";
import logo from "../assets/images/logo.png";

const Header = () => {
  return (
    <header className="w-full shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-8">
          {/* Logo */}
          <a href="/">
            <img src={logo} alt="TruPay Logo" className="h-12 w-auto" />
          </a>

          {/* Navigation Links */}
          <nav className="hidden md:flex space-x-6 text-gray-700 font-medium">
            <a href="#" className="hover:text-teal-500 transition">
              Products
            </a>
            <a href="#" className="hover:text-teal-500 transition">
              Customers
            </a>
            <a href="#" className="hover:text-teal-500 transition">
              Pricing
            </a>
            <a href="#" className="hover:text-teal-500 transition">
              Learn
            </a>
          </nav>
        </div>

        {/* Login / Signup Buttons */}
        <div className="flex space-x-4">
          <button className="px-4 py-2 rounded-md border border-teal-500 text-teal-500 hover:bg-teal-50 transition">
            Log In
          </button>
          <button className="px-4 py-2 rounded-md bg-teal-500 text-white hover:bg-teal-600 transition">
            Sign Up
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
